<ul class="sub-menu-v2 active">
    <app-sidebar2-checkbox
        *ngIf="statuses.length > 0"
        [statuses]="statuses"
        [settingsFlag]="'NavigationV2Contacts'"
        defaultRoute="/contacts/list"
        [routeParam]="'group'"></app-sidebar2-checkbox>
</ul>
